import { Field } from '#app/components/form/field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly companyLegalName: string
	readonly companyLegalNameErrors: readonly string[]
	readonly onCompanyLegalNameChange: (value: string) => void
	readonly responsiblePersonLabelName: string
	readonly responsiblePersonLabelNameErrors: readonly string[]
	readonly onResponsiblePersonLabelNameChange: (value: string) => void
}

export function IdentitySection({
	resources,
	companyLegalName,
	companyLegalNameErrors,
	onCompanyLegalNameChange,
	responsiblePersonLabelName,
	responsiblePersonLabelNameErrors,
	onResponsiblePersonLabelNameChange,
}: Props) {
	return (
		<Section
			title="Company identity"
			description="Record the legal entity that owns MoCRA filings and the label name inspectors will recognize."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-6">
				<Field
					labelProps={{
						children:
							'Which legal entity is responsible for your MoCRA filings?',
					}}
					inputProps={{
						name: 'companyLegalName',
						value: companyLegalName,
						onChange: (event) => onCompanyLegalNameChange(event.target.value),
						type: 'text',
					}}
					descriptionProps={{
						children:
							'Match this to incorporation records—appears on registrations and SOP headers.',
					}}
					errors={
						companyLegalNameErrors.length > 0
							? [...companyLegalNameErrors]
							: undefined
					}
				/>
				<Field
					labelProps={{
						children:
							'What name will appear as the responsible party on product labels?',
					}}
					inputProps={{
						name: 'responsiblePersonLabelName',
						value: responsiblePersonLabelName,
						onChange: (event) =>
							onResponsiblePersonLabelNameChange(event.target.value),
						type: 'text',
					}}
					descriptionProps={{
						children:
							'Include any DBA or suffix so the generated SOPs mirror packaging.',
					}}
					errors={
						responsiblePersonLabelNameErrors.length > 0
							? [...responsiblePersonLabelNameErrors]
							: undefined
					}
				/>
			</div>
		</Section>
	)
}
